import {
  CameraList,
  CameraListResponse,
} from '@apiContract';

import { receivedDigitalApi } from './index';

type CameraListParams = {
  rdConnectInstanceId?: number;
};

const connectOperationsApi = receivedDigitalApi.injectEndpoints({
  endpoints: (builder) => ({
    getCamerasList: builder.query<CameraList, CameraListParams>({
      query: (requestData) => ({
        url: `RdConnectOperations/camera-list/${requestData.rdConnectInstanceId}`,
        params: requestData,
      }),
      transformResponse: (response: CameraListResponse): CameraList => response.objectData,
    }),
  }),
});

export const { useGetCamerasListQuery } = connectOperationsApi;
